import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation files
import enCommon from '../locales/en/common.json';
import hiCommon from '../locales/hi/common.json';
import teCommon from '../locales/te/common.json';
import taCommon from '../locales/ta/common.json';

const resources = {
  en: {
    common: enCommon,
  },
  hi: {
    common: hiCommon,
  },
  te: {
    common: teCommon,
  },
  ta: {
    common: taCommon,
  },
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,

    // Language to use if translations in user language are not available
    fallbackLng: 'en',

    // Default namespace
    defaultNS: 'common',

    // Detection options
    detection: {
      // Order of language detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],

      // Keys to look for in localStorage
      lookupLocalStorage: 'i18nextLng',

      // Cache user language
      caches: ['localStorage'],

      // Optional: Only detect language from specific sources
      checkWhitelist: true,
    },

    // Supported languages
    supportedLngs: ['en', 'hi', 'te', 'ta'],

    // Language codes to use for language detection
    load: 'languageOnly',

    // Allow empty values
    returnEmptyString: false,

    // Options for react-i18next
    react: {
      // Wait for component to be ready before rendering
      useSuspense: false,

      // Bind i18n instance to components
      bindI18n: 'languageChanged',

      // Bind store to components
      bindI18nStore: '',
    },

    interpolation: {
      // React already does escaping
      escapeValue: false,
    },

    // Debug mode (set to false in production)
    debug: process.env.NODE_ENV === 'development',
  });

// Export language information for components
export const languages = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    dir: 'ltr',
  },
  {
    code: 'hi',
    name: 'Hindi',
    nativeName: 'हिंदी',
    dir: 'ltr',
  },
  {
    code: 'te',
    name: 'Telugu',
    nativeName: 'తెలుగు',
    dir: 'ltr',
  },
  {
    code: 'ta',
    name: 'Tamil',
    nativeName: 'தமிழ்',
    dir: 'ltr',
  },
];

export default i18n;